import React, {useContext, useState} from 'react';
import {toast,ToastContainer} from 'react-toastify';
import OrgContext from "../../organisation/OrgContext";
import {useTranslation} from "react-i18next";
import {doc_gen_url} from "../../services/api";
import axios from "axios";

export const Bilan = () => {
        const [t, i18n] = useTranslation();
        const {organisation} = useContext(OrgContext);
    
        const [dateDebut,setDateDebut]=useState("");
        const [dateFin,setDateFin]=useState("");
        const [filterIsValid,setFilterIsValid]=useState(false);
    
        const handleClearFilter=()=>{
            setFilterIsValid(false);
            setDateDebut("");
            setDateFin("");
        }
    
        const handleBilanDownload = async () => {
            const id = toast.loading(
                "Bilan en cours de crèation ...",
                {
                    position: "top-center",
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                }
            );
    
            let tokensData = JSON.parse(localStorage.getItem("tokens"));
            await axios.get(doc_gen_url + `/api/bilan/${organisation.id}`, {
                params:{
                    dateFrom:dateDebut,
                    dateTo:dateFin,
                    filterBydate:filterIsValid,
                },
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `bearer ${tokensData ? tokensData.access_token : ""}`
                },
                responseType: "arraybuffer"
            }).then((response) => {
    
                const type = response.headers["content-type"];
                const blob = new Blob([response.data], {
                    type: type,
                    encoding: "UTF-8",
                });
                const link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "bilan";
                link.click();
    
                toast.update(id, {
                    render: "Bilan a été gènèrer avec succès.",
                    type: "success",
                    isLoading: false,
                });
            })
                .catch((error) => console.log("error " + error));
        };
    
        const handleFilterDate=()=>{
            if (dateDebut === "" || dateFin === "") {
                setFilterIsValid(false);
    // Correction de la faute d’orthographe
                toast.warning(t("Merci de remplir tous les champs"), {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            } else if (dateDebut>dateFin) {
                setFilterIsValid(false);
    
                toast.warning(t("La date de début ne peut pas être supérieure à la date de fin."), {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }else{
                //handle
                setFilterIsValid(true);
                console.log("filtre:" ,dateDebut,dateFin);
                toast.success("Le filtre a été appliqué avec succès", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
    
        }
    
        return (
            <>
                <ToastContainer />
                <div className="page-header">
                    <div className="main-container container-fluid">
                        <div className="page-header">
                            <h1 className="page-title breadcumpsHeader">Bilan Actif et Passif</h1>
                            <div>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="javascript:void(0)">Comptabilité</a>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Bilan Actif et Passif
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6 p-5 text-right">
                                        <div className="col-6 mx-4">
                                            <label htmlFor="dateDebut">{t("Date de début")}:</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                id="dateDebut"
                                                value={dateDebut}
                                                onChange={(e) => setDateDebut(e.target.value)}
                                            />
                                        </div>
                                        <div className="col-6 mx-4 mt-2">
                                            <label htmlFor="dateFin">{t("Date de fin")}:</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                id="dateFin"
                                                value={dateFin}
                                                onChange={(e) => setDateFin(e.target.value)}
                                            />
                                        </div>
                                        <div className="col-6 ">
                                            <button
                                                className="btn btn-primary mt-5 mx-4"
                                                onClick={handleFilterDate}
                                            >
                                                <i className="fa fa-filter"></i>
                                                {t(" Appliquer le filtre")}
                                            </button>
    
                                            <button
                                                className="btn btn-primary mt-5 mx-4"
                                                onClick={handleBilanDownload}
                                            >
                                                <i className="fa fa-download"></i>
                                                {t("Telecharger Bilan Actif et Passif")}
                                            </button>
    
                                        </div>
                                        {
                                            dateDebut !== "" && dateFin !== "" ?
                                                (
                                                    <div className="col-6">
                                                        <button
                                                            className="btn btn-danger mt-5 mx-4"
                                                            onClick={handleClearFilter}
                                                        >
                                                            <i className="fa fa-filter"></i>
                                                            {t(" Vider le filtre")}
                                                        </button>
                                                    </div>
                                                ) : null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
    
        );
}
